"use strict";

window._theme = window._theme || {};

_theme.PageBrands = (function(){
    function init(){
        const brandsList = jQuery('[data-brands-list]');
        const brand = brandsList.find('.brand');
        jQuery('.brands-page .brands-list .brands-hide a').each(function(){
            let $this = jQuery(this);
            let str = jQuery(this).attr('href').split('?q=')[1];
            let v = decodeURI(str);
            let strreg = '';
            let brandlink = '';
            if(v.indexOf('%') == -1){
                brandlink = v.replace(/\s+/g, "-").replace(/\./g, "-").replace(/[^a-zA-Z0-9- ]/g, "").replace(/---/g, "-").replace(/--/g, "-").toLowerCase();
                if(brandlink[brandlink.length-1] == '-'){brandlink = brandlink.slice(0,brandlink.lastIndexOf('-'))}
            }
            else{
                strreg = v.substr(v.indexOf('%'),3);
                brandlink = v.replace(strreg,'-').replace(/\s+/g, "-").replace(/[^a-zA-Z0-9- ]/g, "").replace(/---/g, "-").replace(/--/g, "-").toLowerCase();
                if(brandlink[brandlink.length-1] == '-'){brandlink = brandlink.slice(0,brandlink.lastIndexOf('-'))}
            } 
            $this.closest('.brand-item').find('.brands_link').attr('href',`/collections/${brandlink}`)
        });

        brand.each(function() {
            var self = jQuery(this),
                brandTitle = self.find('.azbrands-title h3').text().trim(),
                character = self.find("ul.brand-grid li:eq(0) a").text().charAt(0).toLowerCase(),
                alphabet = brandsList.prev(),
                alphabetChild = alphabet.children();
      
            alphabetChild.each(function() {
              var aElm = jQuery(this).find('a');
              
              if(aElm.text().trim().toLowerCase() == brandTitle) {
                if(!aElm.hasClass('readonly')) 
                  aElm.addClass('readonly');
                return; 
              }; 
            });
            if(!self.find('.azbrands-title').length) {
              //console.log(character)
              self.find('.brand-grid').children().appendTo('.brand-' + character + " ul.brand-grid");
              self.remove();
            }      
        });

      var vendorItem = brandsList.prev().find('.vendor-letter a.readonly');
      vendorItem.on('click', function() {
        var selfText = jQuery(this).text().trim().toLowerCase();  
        brand.hide().filter(function(e){
          var title =  jQuery(this).find('.azbrands-title h3').text().trim().toLowerCase();  
          if(title == selfText) {
            jQuery(this).show();          
            return;
          };        
        });
        
        jQuery('.azbrandstable .all-brand a').click(function(){
          brand.show();
        });
      });
      
      var allVendor = brandsList.prev().find('a.readonly');
      allVendor.on('click', function() {
        brandsList.prev().find('a').removeClass('active');
        var self = jQuery(this);
        if(!self.hasClass('active')) {
            self.addClass('active');
        };
        var offsetTop = brandsList.prev('.azbrandstable').offset().top;
        jQuery('body,html').animate({
          scrollTop: offsetTop
        }, 600);
      });
      
      var brandList = brandsList.prev().find('a.readonly');
      brandList.each(function(i, e) {
        if (e.hasAttribute("disabled")) {
            e.removeAttribute("disabled");
        }
      });
      
      var filterUrl = new URL(window.location.href)
      var maxHref = filterUrl.searchParams.get('sparameter');
      jQuery('ul.azbrandstable li a').each(function(){
       var t = jQuery(this).text().toLowerCase().trim();
        if(t == maxHref ){
            jQuery(this).trigger('click');
        }
      });
    }

    return { init: init }
})();

jQuery(function(){
    _theme.PageBrands.init();
});